import * as React from 'react'
import { ChangeTag, ChangeTagKind } from 'capacity/components/changeTag/changeTag'
import { ProductTypeIcon } from 'capacity/components/productTypeIcon/productTypeIcon'
import { ProductRowModel } from '../model/rowModel'

const tagFor = (row: ProductRowModel): ChangeTagKind | null => {
    if (row.failed) {
        return 'notSaved'
    }
    return row.status === 'kept' ? null : row.status
}

export function ProductCell({ row }: { row: ProductRowModel }) {
    const tag = tagFor(row)
    return (
        <div className="capacity-product">
            <span className="capacity-product-context" title={row.breadcrumb}>
                {row.breadcrumb}
            </span>
            <span className="capacity-product-name">
                <ProductTypeIcon iconName={row.typeIcon} label={row.typeName} />
                <span className="capacity-product-name-text">{row.member.name}</span>
                {tag && <ChangeTag kind={tag} />}
            </span>
            {row.failed && (
                <span className="capacity-product-context capacity-product-failed" title={row.failed}>
                    {row.failed}
                </span>
            )}
        </div>
    )
}
